<template>
  <v-list-item 
    @click="showDialog()"
    :disabled="!device.isOnline()"
  >
    <v-dialog
      v-if="device"
      v-model="showControl"
      max-width="640px"
    >
      <videon-card :heading="device.deviceName() + ' Video Subsystem'" showClose="true" @close="showControl = false">
        <v-card-text>
          <p class="subtitle-1 my-5">
            Are you sure you want to restart the video subsystem on <span class="primary--text">{{ device.deviceName() }}</span>?
          </p>
          <v-form @submit.prevent="rebootDevice">
            <div class="mt-3 d-flex align-end">
              <v-spacer/>
              <v-btn
                class="ma-1"
                color="secondary"
                @click="showControl = false"
                text
              >
                Cancel
              </v-btn>
              <v-btn
                class="ma-1"
                color="primary"
                @click="restartVideoSubsystem"
              >
                Restart Video Subsystem
              </v-btn>
            </div>
          </v-form>
        </v-card-text>
      </videon-card>
    </v-dialog>
    
    <v-list-item-title>
      <v-icon>power</v-icon>
      Restart Video Subsystem
    </v-list-item-title>
  </v-list-item>
</template>

<script>
  import { mapGetters } from 'vuex'
  
  export default {
    name: 'DecoderRestartVideoSubsystem',
    
    props: ['device'],
    
    data() {
      return {
        error: false,
        errorText: '',
        
        showControl: false,
      }
    },
    mounted() {
      
    },
    watch: {
      
    },
    computed: {
      ...mapGetters('user', ['isDeviceAdmin']),
      
      loading() {
        if (this.device.isCommandProcessing()) {
          return true
        }
        return false
      },
    },
    
    methods: {
      showDialog() {
        this.device.resetCommandState()
        this.showControl = true
      },
      restartVideoSubsystem() {
        this.device.runCommand('restart_video_subsystem')
        this.showControl = false
      },
    }
  }
</script>